import CAAA1040RequestModel from '@/api/data/CAA/CAAG1040/CAAA1040RequestModel'
import CAAA1040ResponseModel from '@/api/data/CAA/CAAG1040/CAAA1040ResponseModel'
import ApiUrlConstants from '@/common/ApiUrlConstants'
import RestService from '@/common/RestService'

export default class CAAG1040Service {
  private caaa1040RequestModel = new CAAA1040RequestModel()
  /**
   * お知らせ一覧（ログイン前）初期表示の情報取得
   * @returns APIからのレスポンスデータ
   */
  public async callAPICAAA1040() {
    const caaa1040ResponseModel: CAAA1040ResponseModel = <
      CAAA1040ResponseModel
    > await RestService.post(ApiUrlConstants.CAAA1040, this.caaa1040RequestModel)
    return caaa1040ResponseModel
  }
}
